import styled, { css } from 'styled-components';
import { pointer } from '@10d/tend-ui-styling';

const Root = styled.span.attrs({
    $sizes: {
        large: css `
      width: 48px;
      height: 48px;
    `,
        medium: css `
      width: 40px;
      height: 40px;
    `,
        small: css `
      width: 32px;
      height: 32px;
    `,
    },
}) `
  font-family: Museo Sans Cyrl;
  color: ${props => props.theme.colors.blue600};
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;

  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 50%;
  background-color: ${props => props.theme.colors.blue100};
  overflow: hidden;
  ${props => props.$sizes[props.$size]};
  ${pointer};
`;

export { Root };
//# sourceMappingURL=styled.js.map
